(function ($, window) {
  $.fn.startTransactionReview = function () {
    this.each(function () {
      switch (this.tagName.toLowerCase()) {
        case "a":
          handleAnchorTag(this);
          break;

        case "li":
          handleListItem(this);
          break;
      }
    });

    function clearInPageMessages() {
      $("#error, #message").find("p").text("");
    }

    function handleAnchorTag(link) {
      var formSection = $(link).parents(".govuk-form-group");
      var notificationPlaced = false;

      $(link).on("click", function (event) {
        if (notificationPlaced) {
          notificationPlaced = false;
          window.location = link.href;
          return;
        }

        event.preventDefault();

        clearInPageMessages();

        var infoBanner = $(
          '<div class="notice govuk-blue-banner js-banner-with-close">',
        );
        var icon = $(
          '<i class="icon fa fa-exclamation-circle fa-lg"><span class="visually-hidden">Information</span></i>',
        );
        var message = $(
          '<strong class="font-large">Please refresh this page once the file has finished downloading. You can press "F5"</strong>',
        );
        infoBanner.append(icon).append(message).closeNotification();

        infoBanner
          .css({
            marginBottom: "30px",
          })
          .find(".icon-close")
          .css({
            marginTop: "-7px",
            transform: "scale(1.25)",
          });

        icon.css({
          marginTop: "-9px",
        });

        message.css({
          color: "#FFF",
          fontSize: "19px",
          paddingLeft: "60px",
        });

        notificationPlaced = true;

        formSection.find(".notice").remove();

        formSection.prepend(infoBanner);

        $(link).trigger("click");
      });
    }

    function handleListItem(listItem) {}
  };
})(jQuery, window);
